'use strict';

var FilterContainerView = require('./filter_container.view');
var AppliedFiltersSummaryView = require('../../modules/views/results/applied_filters_summary.view');
var summaryLabelMixin = require('../../modules/views/results/summary_label');
var viewInjectorUtils = require('../../modules/views/view_injector_utils');
var createView = viewInjectorUtils.createView;

var createAppliedFiltersSummaryView = function(viewFactories, options) {
    return createView(viewFactories, AppliedFiltersSummaryView, Odigeo._.extend({
        className: 'summary_label odf-text-sm',
        tagName: 'span',
        summaryLabel: {
            viewClass: Backbone.View.extend(summaryLabelMixin),
            tagName: 'span',
            className: 'od-filters-summary-label',
        },
        templates: this.templates,
    }, options));
};

var createFilterContainerView = function(viewFactories, options) {
    return createView(viewFactories, FilterContainerView, Odigeo._.extend({
        templates: this.templates,
    }, options));
};

module.exports = viewInjectorUtils.createInjector({
    appliedFiltersSummary: createAppliedFiltersSummaryView,
    filterContainer: createFilterContainerView,
});
